import React, { FC } from 'react';

import { useTranslations } from '~/context/TranslationContext/TranslationsContext';
import { CardMeta as CardMetaType } from '~/mappers/card/models';
import getLocalTimeData from '~/utils/getLocalTime';
import { ConsumptionType, getConsumptionTypeLabel } from '~/utils/translation';

import { shouldIncludeTime } from '../../utils/shouldIncludeTime';

type Props = {
  meta?: CardMetaType | null;
  className?: string;
};

export const CardMeta: FC<Props> = ({ meta, className }) => {
  const t = useTranslations();

  if (!meta) return null;

  const timeZone = process.env.GATSBY_HCP_SITE_IANA_TIME_ZONE;
  const locale = process.env.CONTENTSTACK_LOCALES;
  const { resourceConsumptionType } = meta;

  const eventStartDate = getLocalTimeData(
    meta.rawDate ?? meta.date ?? '',
    timeZone,
    locale
  );

  const autoIncludeTime = shouldIncludeTime(meta.rawDate);

  const dateStr = autoIncludeTime
    ? `${eventStartDate?.formattedSimpleDate} ${eventStartDate?.formattedTimeShort}`
    : eventStartDate?.formattedSimpleDate;

  const duration = meta.durationMinutes;

  if (!dateStr && (duration === null || duration === undefined)) return null;

  return (
    <div className={className ?? 'cds-card__page-additional-data'}>
      {dateStr && (
        <span className="cds-card__page-additional-data__date">{dateStr}</span>
      )}
      {typeof duration === 'number' && (
        <span className="cds-card__page-additional-data__duration">
          {`${duration} ${t?.card?.timeUnit} ${
            resourceConsumptionType
              ? getConsumptionTypeLabel(
                  resourceConsumptionType as ConsumptionType,
                  t
                )
              : ''
          }`}
        </span>
      )}
    </div>
  );
};

export default CardMeta;
